import { render, staticRenderFns } from "./DxPopup.vue?vue&type=template&id=5d909ea6&"
import script from "./DxPopup.vue?vue&type=script&lang=js&"
export * from "./DxPopup.vue?vue&type=script&lang=js&"
import style0 from "./DxPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports